import { render, staticRenderFns } from "./ContainersManager.vue?vue&type=template&id=61897d3b&"
import script from "./ContainersManager.vue?vue&type=script&lang=ts&"
export * from "./ContainersManager.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports